import React from 'react';

import type { Stripe } from '@stripe/stripe-js';

export type StripeInstanceContextValue = {
  stripeInstance: Stripe | null;
  stripeInstanceLoading: boolean;

  /**
   * You should call this method once in places where you need to use Stripe
   */
  initStripe: () => Promise<void>;
};

export const StripeInstanceContext = React.createContext<StripeInstanceContextValue>({
  stripeInstance: null,
  stripeInstanceLoading: false,
  initStripe: async () => {},
});
